import React, { useState } from 'react';

import { Close } from '@mui/icons-material';
import {
  IconButton,
  Stack,
  Typography,
} from '@mui/material';

import ContentCard from '../../../components/ContentCard';
import Link from '../../../components/Link';
import SearchField from '../../../components/SearchField';
import {
  useUpdateExamMarkingRequestMutation,
} from '../../../services/exams';
import { useGetStaffsQuery } from '../../../services/staff';
import useError from '../../../utils/react/hooks/useError';

type Marker = {
  staffId: string,
  name: string,
};

interface RequestMarkerCardProps {
  requestId: string,
  marker?: Marker
}

const RequestMarkerCard = ({
  requestId, marker,
}: RequestMarkerCardProps) => {
  const [searchStr, setSearchStr] = useState('');

  const { data: searchedMarkers, isFetching: isSearchedMarkersLoading } = useGetStaffsQuery({
    search: searchStr,
    excludeDisabled: true,
  }, { skip: searchStr === '' });

  const [updateMarkingRequest, {
    isError: isUpdateMarkingRequestError,
    error: updateMarkingRequestError,
  }] = useUpdateExamMarkingRequestMutation();

  useError(isUpdateMarkingRequestError, updateMarkingRequestError);

  return (
    <ContentCard title="Marker" variant="outlined">
      <Stack direction="column" spacing={2}>
        {marker ? (
          <ContentCard variant="contained" padding="small">
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              paddingLeft={2}
              paddingRight={2}
            >
              <Link href={`/admin/staff/${marker.staffId}`} fontWeight="bold">
                {marker.name}
              </Link>
              <IconButton onClick={() => {
                updateMarkingRequest({
                  requestId,
                  newAttributes: {
                    marker: '',
                  },
                });
              }}
              >
                <Close />
              </IconButton>
            </Stack>
          </ContentCard>
        ) : (
          <SearchField
            type="dropdown"
            placeholder="Search markers..."
            options={searchedMarkers?.data || []}
            getOptionKey={(m) => m.staffId}
            getOptionLabel={(m) => m.name}
            onSearch={(search) => setSearchStr(search)}
            loading={isSearchedMarkersLoading}
            onSelect={(m) => {
              updateMarkingRequest({
                requestId,
                newAttributes: {
                  marker: m.staffId,
                },
              });
            }}
            renderOption={(props, m) => (
              <li {...props}>
                <Typography key={m.id}>
                  {m.name}
                </Typography>
              </li>
            )}
            clearOnSelect
          />
        )}
      </Stack>
    </ContentCard>
  );
};

export default RequestMarkerCard;
